// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.local-img {
  width: 100%;
  max-height: 230px !important;
  object-fit: cover;
}

.light-color {
  background: #FFFFFF;
}

.local-title {
  font-weight: bold;
  font-size: 1.2em;
}

.local-description {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/location/location.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,4BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,yBAAA;AACJ","sourcesContent":[".local-img {\n    width: 100%;\n    max-height: 230px!important;\n    object-fit: cover;\n}\n\n.light-color {\n    background: #FFFFFF;\n}\n\n.local-title {\n    font-weight: bold;\n    font-size: 1.2em;\n}\n\n.local-description {\n    font-weight: 400;\n    color: rgba(0,0,0,0.5);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
